// extracted by mini-css-extract-plugin
export default {"viewport":"xFO7J6","overview":"GwHogE","item":"U_V8qL","includeBanner":"xUjZRl","prev":"TqRA_s","next":"Ws4Den","dots":"hgSxgM","dot":"huEAB9","dotActive":"hc9cEH"};